// src/components/ChangePassword.js
import React, { useState } from 'react';
import { EmailAuthProvider, reauthenticateWithCredential, updatePassword } from 'firebase/auth';
import { auth } from '../firebase';
import PasswordInput from './PasswordInput';
import './ChangePassword.css';

const ChangePassword = () => {
  const [form, setForm] = useState({ current: '', next: '', confirm: '' });
  const [saving,  setSaving]  = useState(false);
  const [success, setSuccess] = useState(false);
  const [error,   setError]   = useState('');

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);

    if (form.next.length < 6) {
      setError('New password must be at least 6 characters.');
      return;
    }
    if (form.next !== form.confirm) {
      setError('New passwords do not match.');
      return;
    }

    const user = auth.currentUser;
    if (!user || !user.email) {
      setError('No authenticated user found. Please log in again.');
      return;
    }

    setSaving(true);
    try {
      console.log('[ChangePassword] Reauthenticating user:', user.email);
      const credential = EmailAuthProvider.credential(user.email, form.current);
      await reauthenticateWithCredential(user, credential);
      console.log('[ChangePassword] Reauthentication successful — updating password...');
      await updatePassword(user, form.next);
      console.log('[ChangePassword] Password updated successfully.');
      setSuccess(true);
      setForm({ current: '', next: '', confirm: '' });
    } catch (err) {
      console.error('[ChangePassword] Error:', err.code, err.message);
      if (err.code === 'auth/wrong-password' || err.code === 'auth/invalid-credential') {
        setError('Current password is incorrect.');
      } else if (err.code === 'auth/weak-password') {
        setError('New password is too weak — use at least 6 characters.');
      } else if (err.code === 'auth/requires-recent-login') {
        setError('Session expired. Please log out and log back in, then try again.');
      } else {
        setError(`Something went wrong: ${err.message}`);
      }
    }
    setSaving(false);
  };

  return (
    <div className="cp-section">
      <div className="cp-section-label">Change Password</div>
      <form className="cp-form" onSubmit={handleSubmit}>
        <div className="cp-form-group">
          <label className="cp-label">Current Password</label>
          <PasswordInput
            className="cp-input"
            name="current"
            placeholder="Enter current password"
            value={form.current}
            onChange={handleChange}
            autoComplete="current-password"
          />
        </div>
        <div className="cp-form-group">
          <label className="cp-label">New Password</label>
          <PasswordInput
            className="cp-input"
            name="next"
            placeholder="At least 6 characters"
            value={form.next}
            onChange={handleChange}
            autoComplete="new-password"
          />
        </div>
        <div className="cp-form-group">
          <label className="cp-label">Confirm New Password</label>
          <PasswordInput
            className="cp-input"
            name="confirm"
            placeholder="Repeat new password"
            value={form.confirm}
            onChange={handleChange}
            autoComplete="new-password"
          />
        </div>

        {error   && <div className="cp-error">{error}</div>}
        {success && <div className="cp-success">✓ Password updated successfully.</div>}

        <button
          type="submit"
          className="btn btn-outline btn-sm cp-submit"
          disabled={saving || !form.current || !form.next || !form.confirm}
        >
          {saving ? 'UPDATING...' : 'UPDATE PASSWORD'}
        </button>
      </form>
    </div>
  );
};

export default ChangePassword;
